var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-header-nav-more"},[_c('app-header-nav-more-social'),_c('app-header-nav-more-local')],1)}
var staticRenderFns = []

export { render, staticRenderFns }